import graphServiceJson from "./graph-service.json" assert { type: "json" };
export { graphServiceJson };
//# sourceMappingURL=graph-service-json.js.map